/*
 * Events as a context. The front-end manifest, see lib/docs/extensions/writing-an-extension.md.
 */
import { defineExtension } from '@lib/extensions/define';
import { hasExtension } from '@lib/utils/eflib';

import de from './locale/de';
import en from './locale/en';

export default defineExtension({
	name: 'events',
	locale: { de, en },
	slots: {
		'context.settings': [
			// The teams at an event; adding and removing them is checked by the routes and the tab
			{
				id: 'teams',
				icon: 'fa-building',
				group: 'members',
				contexts: ['event'],
				when: () => hasExtension('teams'),
				ability: 'read',
				order: 110,
				component: () => import('./settings/EventTeamsTab.vue'),
			},
			// The events of a team
			{
				id: 'events',
				icon: 'fa-campground',
				group: 'general',
				contexts: ['team'],
				ability: 'read',
				order: 10,
				component: () => import('./pages/TeamEvents.vue'),
				props: ({ context, record }) => ({ context, contextId: record.id }),
			},
		],
	},
	// The settings of one event, see pages/Context/ContextSettings.vue; the app spreads extensionRoutes()
	routes: [
		{
			path: 'events/:id/settings',
			name: 'events.settings',
			component: () => import('@lib/pages/Context/ContextSettings.vue'),
			props: (route) => ({ context: 'event', id: route.params.id }),
		},
	],
});
